export default function(options) {
  const tabId = _.random(true).toString(36).substring(2, 15) +
                _.random(true).toString(36).substring(2, 15);
  const defaults = {
    key: 'vuex-multi-tab',
    namespace: [],
    paths: [],
    onBeforeReplace: (state) => state
  }
  const mergedOptions = _.merge({}, defaults, options)
  const {key, paths, namespace, onBeforeReplace} = mergedOptions

  const channel = new BroadcastChannel(key);
  // debugLog({tabId, channel, mergedOptions})

  function filterStates(state) {
    const result = {};
    paths.forEach(statePath => {
      _.set(result, statePath, _.get(state, statePath));
    });
    return result;
  }

  function mergeState(oldState, newState) {
    // if whole state is to be replaced then do just that
    if (paths.length === 0) return { ...newState };

    // else clone old state
    const merged = _.cloneDeep(oldState);

    // and replace only specified paths
    paths.forEach(statePath => {
      const newValue = _.cloneDeep(_.get(newState, statePath));
      // remove value if it doesn't exist, overwrite otherwise
      if (typeof newValue === 'undefined') {
        _.unset(merged, statePath);
      } else {
        _.set(merged, statePath, newValue);
      }
    });
    return merged;
  }

  function replaceState(store, state) {
    const adjustedState = onBeforeReplace(state);
    if (adjustedState && !_.isEmpty(adjustedState)) {
      store.replaceState(mergeState(store.state, adjustedState));
    }
  }

  return (store) => {
    channel.onmessage = (event) => {
      const {data} = event
      const {sender, state, action} = data
      if (action === 'update' && sender && sender !== tabId) {
        replaceState(store, state)
      }
    };

    store.subscribe((mutation, state) => {
      const mutationType = mutation.type
      if (namespace) {
        if (!_.startsWith(mutationType, namespace + '/')) {
          return;
        }
      }

      let toSave = state;
      if (paths.length > 0) {
        toSave = filterStates(state);
      }
      if (toSave && !_.isEmpty(toSave)) {
        channel.postMessage({action: 'update', state: toSave, sender: tabId, options: _.omit(mergedOptions, ['onBeforeReplace'])})
      }
    });
  };
}
